export const ADD_SNACK_MESSAGE = "ADD_SNACK_MESSAGE";
export const REMOVE_SNACK_MESSAGE = "REMOVE_SNACK_MESSAGE";
